import {
  Pipe,
  ChangeDetectorRef,
  Inject,
  Optional,
  PipeTransform,
} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { FeatureTranslationKey } from '../../feature-translation.module';
import { translationKeyExists } from '../../helpers';

@Pipe({
  name: 'translate',
  pure: false,
})
export class LibTranslatePipe extends TranslatePipe implements PipeTransform {
  constructor(
    public translateService: TranslateService,
    public cdr: ChangeDetectorRef,
    @Optional()
    @Inject(FeatureTranslationKey)
    private featureTranslationKey: string,
  ) {
    super(translateService, cdr);
  }

  override transform(query: string, ...args: unknown[]): string {
    if (this.featureTranslationKey) {
      const keySlices = this.featureTranslationKey.split('.');
      for (let i = keySlices.length; i > -1; i--) {
        const prefix = keySlices.join('.');
        const checkKey = `${prefix}${prefix ? '.' : ''}${query}`;
        const translation = super.transform(checkKey, ...args) as string;
        if (translationKeyExists(translation, checkKey)) {
          return translation;
        }
        keySlices.pop();
      }
      return super.transform(
        `${this.featureTranslationKey}.${query}`,
        ...args,
      ) as string;
    }
    return super.transform(query, ...args) as string;
  }
}
